import { Suspense, lazy, memo } from "react";
import { useMemo, useRef } from "react";
// import { UploadOptions } from "@maysoft/tus-js-client";

import Box from "../Box";
import Typography from "../Typography";
import Helpers from "../../commons/helpers";
// import useStrings from "../../hooks/useStrings";
// import { Constants } from "../../constants/constants";
import { FileAccessMode, FileProcessingStatus, Mode } from "../../constants/enums";
// import { useCommonComponentContext } from "../../providers/CommonComponentProvider";
// import ResumableUploadService, { ResumableUploadRequest } from "../../services/asset/resumableUpload.service";

import "./styles.css";
// import { Jodit } from "jodit";
const JoditEditor = lazy(() => import("jodit-react"));

export interface Props {
    mode?: number;
    value?: string;
    label?: string;
    disable?: boolean;
    readonly?: boolean;
    required?: boolean;
    isFullRow?: boolean;
    placeholder?: string;
    errorMessage?: string;
    hideToolbar?: boolean;
    maxHeight?: number | string;
    editHTMLDocumentMode?: boolean;
    onBlur?: (value: string) => void;
    onChangeValue?: (value: string) => void;
}

const InputHtmlEditor: React.FC<Props> = (props: Props) => {
    // const {
    //     serviceCode,
    //     tenantCode,
    //     onError,
    //     onShowLoading,
    //     onHideLoading
    // } = useCommonComponentContext();
    // const strings = useStrings();

    const editor = useRef(null);
    const config: any = {
        // value: props.value,
        height: props.maxHeight || "auto",
        readonly: props.mode === Mode.View || props.readonly, // all options from https://xdsoft.net/jodit/docs/,
        placeholder: props.placeholder || "",
        toolbar: props.mode === Mode.View || props.hideToolbar ? false : true,
        statusbar: props.mode === Mode.View || props.hideToolbar ? false : true,
        iframe: true, // enable iframe mode,
        editHTMLDocumentMode: props.editHTMLDocumentMode,

        // removeButtons: ["image", "video", "file"],
        // extraButtons: ["|", "uploadImage"],
    };

    const typographyProps: any = useMemo(() => {
        if (props.mode === Mode.View)
            return {
                variant: "button",
                fontWeight: "bold",
                color: "dark",
            };
        return {
            variant: "caption",
            fontWeight: "regular",
            color: Helpers.isNullOrEmpty(props.errorMessage) ? "secondary" : "error",
        };
    }, [props.mode, props.errorMessage]);

    // Jodit.defaultOptions.controls.uploadImage = useMemo(() => {
    //     if (Helpers.isNullOrEmpty(serviceCode) ||
    //         Helpers.isNullOrEmpty(tenantCode) ||
    //         Helpers.isNullOrEmpty(strings) ||
    //         !Helpers.isFunction(onShowLoading) || 
    //         !Helpers.isFunction(onHideLoading) ||
    //         !Helpers.isFunction(onError)
    //     ) {
    //         return {};
    //     }

    //     return ({
    //         name: `Upload ${strings.Common.IMAGE.toLowerCase()}`,
    //         exec: (async (editor: any) => {
    //             await handleImageUpload(
    //                 editor,
    //                 serviceCode,
    //                 tenantCode,
    //                 strings.Common.ERROR,
    //                 onError,
    //                 onShowLoading,
    //                 onHideLoading
    //             );
    //         })
    //     })
    // }, [serviceCode, tenantCode, strings, onError, onShowLoading, onHideLoading])

    return (
        <Box>
            <Box>
                <Typography {...typographyProps}>{`${props.label} ${props.required ? "*" : ""}`}</Typography>
            </Box>

            <Suspense fallback="Loading rich text input...">
                <JoditEditor
                    ref={editor}
                    config={config}
                    value={props.value}
                    onChange={(newContent) => {
                        Helpers.isFunction(props.onChangeValue) && props.onChangeValue(newContent);
                    }}
                    onBlur={(newContent) => {
                        Helpers.isFunction(props.onBlur) && props.onBlur(newContent);
                    }}
                />
            </Suspense>
            {!Helpers.isNullOrEmpty(props.errorMessage) && (
                <Box>
                    <Typography variant="caption" color="error">
                        {props.errorMessage}
                    </Typography>
                </Box>
            )}
        </Box>
    );
};

// const handleImageUpload = async (
//     editor: any,
//     serviceCode: string,
//     tenantCode: string,
//     errorUploadMessage: string,

//     onError: (message: string) => void,
//     onShowLoading: () => void,
//     onHideLoading: () => void,
// ) => {
//     const input = document.createElement("input");
//     input.setAttribute("type", "file");
//     input.setAttribute("accept", "image/*");
//     input.click();

//     input.onchange = async () => {
//         const file = input.files ? input.files[0] : null;

//         if (Helpers.isNullOrEmpty(file)) {
//             return;
//         }

//         if (Helpers.isNullOrEmpty(editor)) {
//             return;
//         }

//         console.log(editor.selection.insertImage)

//         try {
//             onShowLoading();
//             // editor.selection.focus();

//             const request: ResumableUploadRequest = {
//                 folderPath: Constants.CloudStorage.EDITOR_CONTENT_FOLDER,
//                 processingStatus: `${FileProcessingStatus.Processed}`,
//                 accessMode: `${FileAccessMode.Public}`,
//                 tenantCode: tenantCode,
//                 serviceCode: serviceCode
//             };

//             const options: UploadOptions = {
//                 onSuccess: (res) => {
//                     let accessUrl = "";
//                     if (res.getHeader("asset-url")) {
//                         accessUrl = res.getHeader("asset-url");
//                     }

//                     if (res.getHeader("asset-error")) {
//                         onError(errorUploadMessage);
//                     }

//                     if (!Helpers.isNullOrEmpty(accessUrl)) {
//                         editor.selection.insertImage(accessUrl, null, 250);
//                     }

//                     onHideLoading();
//                 },
//                 onError: (error) => {
//                     onError(Helpers.renderExceptionError(error));
//                 },
//             };

//             const tusUpload = ResumableUploadService.upload(file, request, options);
//             tusUpload.start();
//         } catch (error) {
//             console.log(error)
//             onError(Helpers.renderExceptionError(error));
//         }
//     }
// }

// Declaring default props for InputHtmlEditor
InputHtmlEditor.defaultProps = {
    label: "",
};

// export default memo(InputHtmlEditor);
export default memo(InputHtmlEditor, (prev, next) => {
    if (
        prev.mode !== next.mode ||
        prev.value !== next.value ||
        prev.label !== next.label ||
        prev.placeholder !== next.placeholder ||
        prev.disable !== next.disable ||
        prev.readonly !== next.readonly ||
        prev.required !== next.required ||
        prev.isFullRow !== next.isFullRow ||
        prev.hideToolbar !== next.hideToolbar ||
        prev.maxHeight !== next.maxHeight ||
        prev.onBlur !== next.onBlur ||
        prev.onChangeValue !== next.onChangeValue ||
        prev.errorMessage !== next.errorMessage
    )
        return false;
    return true;
});
